
var scripts = document.getElementsByTagName( "script" );
var lastScript = scripts[scripts.length - 1];

class Configuration {

  getScriptURL = () => {
    let script : any =  document.currentScript || document.querySelector('script[src*="js/v1_0/webchat.js"]');
    return script.src
  };

  SERVICE_URL = `${new URL(this.getScriptURL()).origin}`;
}

export const configuration = new Configuration();

